import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, MapPin } from "lucide-react";
import { api } from "@/lib/api";

function fmt(n) {
  if (!n) return "—";
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(0)}K`;
  return n;
}

export default function TalentsTeaser() {
  const [talents, setTalents] = useState([]);
  useEffect(() => {
    api.get("/talents?featured=true").then(setTalents).catch(() => setTalents([]));
  }, []);

  return (
    <section className="py-24 lg:py-32" data-testid="talents-teaser">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <p className="text-xs uppercase tracking-[0.3em] text-primary mb-4 font-bold">Talentos</p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[1]">
              Una red nacional de <span className="gradient-text">creadores e influencers</span>.
            </h2>
          </div>
          <Link to="/talentos" data-testid="talents-teaser-cta" className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-widest hover:text-primary transition-colors group">
            Ver todos los talentos
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 lg:gap-5">
          {talents.slice(0, 6).map((t, i) => (
            <motion.div
              key={t.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.07 }}
            >
              <Link to={`/talentos/${t.id}`} className="block group" data-testid={`talent-teaser-${t.id}`}>
                <div className="relative aspect-[3/4] overflow-hidden rounded-sm bg-secondary border border-border">
                  {t.photo && (
                    <img src={t.photo} alt={t.artist_name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent opacity-80 group-hover:opacity-90 transition-opacity" />
                  <div className="absolute top-3 left-3 right-3 flex justify-between text-[10px] uppercase tracking-widest text-white">
                    <span className="bg-primary px-2 py-0.5 rounded-sm">{t.category?.split("/")[0]?.trim()}</span>
                  </div>
                  <div className="absolute bottom-3 left-3 right-3 text-white">
                    <div className="font-display font-black text-base lg:text-lg leading-tight">{t.artist_name}</div>
                    <div className="flex items-center gap-1 text-[11px] text-white/70 mt-1">
                      <MapPin className="w-3 h-3" /> {t.city}
                    </div>
                    <div className="text-[11px] text-white/80 mt-2 font-semibold">
                      IG {fmt(t.followers_instagram)} · TT {fmt(t.followers_tiktok)}
                    </div>
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
